<template>
  <section>
    <Banner value="História"/>

    <Fotos/>

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p
              class="lead"
            >A Escola Engenho foi fundada em 07 de janeiro de 1991, como resultado da associação de Isabel Ouriques e Cleusa Maria Antunes Meurer. Seu nome veio dos engenhos de farinha do Campeche e sugere a transformação ocorrida com os alunos frente ao conhecimento sistematizado pela escola.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>


    <v-container grid-list-lg>
      <v-layout row wrap my-4>
        <v-flex xs12>
          <p
            class="lead"
          >Num primeiro momento, a Escola dedicava-se somente à Educação Infantil, sob a direção de Cleusa Meurer, e funcionava numa casa alugada, com três salas, um pátio e uma área parcialmente coberta. Em meados de 1993, a Engenho mudou-se para instalações próprias, onde se encontra hoje, num terreno situado entre o trevo do Campeche e a praia.</p>
        </v-flex>
        <v-flex xs12>
          <p>Inicialmente a Escola atendia às famílias do bairro e, com o passar do tempo e a divulgação de sua proposta pedagógica, passou a atender também os bairros circunvizinhos, como Rio Tavares, Açores, Morro das Pedras, Ribeirão da Ilha, Armação, Lagoa da Conceição, Pântano do Sul e Tapera.</p>
        </v-flex>
        <v-flex xs12>
          <p>O projeto da nova sede da Escola foi idealizado pela direção, com a cooperação de várias pessoas (entre elas arquitetos e engenheiros) e com orientações formais da Secretaria de Educação, incluindo a construção do parque, biblioteca, laboratório de ciências, sala de arte-educação, sala dos professores e, posteriormente, do andar superior, com duas novas salas de aula. Em 2001 e 2002, o projeto foi finalizado, com mais salas de aula, banheiros, etc.</p>
        </v-flex>
        <v-flex xs12>
          <p>A Escola trabalha com Educação Infantil e Ensino Fundamental (do 1º ao 9º ano), distribuídos no período matutino e vespertino, num trabalho que envolve quarenta profissionais, sob a responsabilidade de André Luiz Rodrigues, diretor geral da Escola.</p>
        </v-flex>
        <v-flex xs12>
          <p>Alguns fatos têm marcado a trajetória da Escola, como a aprovação de seu funcionamento para Educação Infantil em 1991, para o Ensino Fundamental (1ª a 4ª séries) em 1994 e para 5ª a 8ª séries em 2001, pela Secretaria Estadual de Educação e Conselho Estadual de Educação. Nesta época, a direção já vinha rediscutindo o projeto pedagógico com o corpo docente, demais funcionários, pais e alunos da comunidade escolar.</p>
        </v-flex>
        <v-flex xs12>
          <p>Com certeza, um dos fatos mais marcantes de toda esta história foi a formatura da primeira turma de 4ª série, no final de 1997, indicando a consumação de uma etapa decisiva na atuação da Escola. Em 2003, formou-se a primeira turma de 8ª série.</p>
        </v-flex>
        <v-flex xs12>
          <p>Em 2006, continuamos a ampliação e melhoria das instalações com a reforma dos banheiros e das salas de aula da Educação Infantil. Foram realizados investimentos nos equipamentos de informática, na aquisição de livros para a Biblioteca, brinquedos e material didático para a Educação Infantil.</p>
        </v-flex>
        <v-flex xs12>
          <p>Em 2007, foi adotado o regime de nove anos para o Ensino Fundamental. Neste ano construímos a Quadra de Esportes, finalizando essa obra com a sua cobertura em 2008. Neste ano também foram adquiridos móveis para a biblioteca, além de novos equipamentos de informática e novos televisores.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import Fotos from "../../components/historia/Fotos.vue";

export default {
  data: () => ({}),
  components: {
    Banner,
    Fotos
  }
};
</script>

<style lang="scss" scoped>
p,
h2 {
  text-align: justify !important;
}
</style>

